import { useEffect, useRef, useState } from 'react'
import DatePicker from '../DatePicker'
import { PrismSelect } from '@prism-ui/react'
import { DateTime } from 'luxon'
import './DateTimePicker.css'

const hourOptions = new Array(24).fill(0).map((_,i)=>{
  const l = (i%12 === 0) ? `12:00 ${i === 0 ? 'AM':'PM'}` : i < 12 ? `${i}:00 AM` : `${i-12}:00 PM`  // BUG FIX: Use strict equality
  const v = i < 10 ? `0${i}:00` : `${i}:00`
  return {display:l, value:v}
})

const tzAbbr = (d:string, h:string) => {
  if (!d || !d.trim()) return ''
  return DateTime.fromISO(d.slice(0,11) + h).toFormat('ZZZZ')
}

interface Props {
  value:string // iso-format
  onChange:(s:string)=>void
  invalid?:boolean
  disabled?:boolean
}
const DateTimePicker = ({value, onChange, invalid=false, disabled=false}:Props) => {
  const d = new Date(value)
  const [date, _setDate] = useState(d.toLocaleDateString('sv')+'T00:00Z')
  const [hour, _setHour] = useState(hourOptions[d.getHours()].value)

  // PrismSelect re-fires prismChange when its value is set programmatically;
  // the ref lets us drop those echoes instead of reporting a spurious change.
  const hourRef = useRef(hourOptions[d.getHours()].value)

  const dateFor = (d:string, h:string) => new Date(d.slice(0,11) + h)
  const setDate = (s:string) => {
    if (!s) return
    _setDate(s)
    const d = dateFor(s, hourRef.current)
    if (onChange) onChange(d.toISOString())
  }
  const setHour = (h:string) => {
    if (!h || h === hourRef.current) return
    _setHour(h)
    hourRef.current = h
    const d = dateFor(date, h)
    if (onChange) onChange(d.toISOString())
  }

  useEffect(()=>{
    _setDate(d.toLocaleDateString('sv')+'T00:00Z')
    _setHour(hourOptions[d.getHours()].value)
    hourRef.current = hourOptions[d.getHours()].value
  }, [value])

  return (
    <div className='datetime-picker clr:flex clr:items-center'>
      <DatePicker utc
        value={value} onChange={setDate}
        className='clr:mr-2'
        placeholder='Pick a date...'
        disabled={disabled}
        isInvalid={invalid}
      />
      <PrismSelect
        label='Hour'
        hideLabel
        invalid={invalid}
        value={hour}
        options={hourOptions}
        disabled={disabled}
        onPrismChange={(e:any)=>setHour(String(e.detail?.value ?? e.detail ?? ''))}
      />
      <span className='tz-abbr'>{tzAbbr(date, hour)}</span>
    </div>
  )
}
export default DateTimePicker